import React from 'react'

import styles from './DynamicInput.module.css'

export default function Entity({ entity, getLabel, onDelete }) {
  return (
    <span className={styles.entity}>
      {`${getLabel(entity)} `}
      <span className={styles.deleteEntity} onClick={onDelete}>
        ×
      </span>
    </span>
  )
}
